import TestFlowViewConfig from 'automation-ui-canvas/containers/flow-views/TestFlowViewConfig';
import GoToActionFlowViewConfig from 'automation-ui-canvas/containers/flow-views/go-to-action/GoToActionFlowViewConfig';
import CollabGenActionsFlowViewConfig from 'automation-ui-canvas/containers/flow-views/CollabGenActionsFlowViewConfig';
export const FlowViewConfigs = {
  [TestFlowViewConfig.id]: TestFlowViewConfig,
  [GoToActionFlowViewConfig.id]: GoToActionFlowViewConfig,
  [CollabGenActionsFlowViewConfig.id]: CollabGenActionsFlowViewConfig
};